"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.0075 19.9995C20.7657 19.9995 21.4927 19.6984 22.0287 19.1624C22.5646 18.6265 22.8658 17.8994 22.8658 17.1414V8.97547C22.8658 8.06589 22.5043 7.19362 21.8612 6.55049C21.218 5.90709 20.3457 5.54592 19.4358 5.54592H3.91252C3.49151 5.54618 3.08681 5.38307 2.78336 5.09075C2.48016 4.7987 2.30228 4.40023 2.28674 3.97947C2.30202 3.53026 2.48922 3.10409 2.80977 2.78899C3.13031 2.47415 3.55958 2.29421 4.00913 2.28696H19.4356C19.7388 2.28696 20.0299 2.40735 20.2442 2.62173C20.4586 2.83611 20.579 3.12687 20.579 3.43004V3.81607C20.579 4.22464 20.7968 4.60184 21.1507 4.80619C21.5044 5.01047 21.9402 5.01047 22.2939 4.80619C22.6476 4.60191 22.8656 4.22467 22.8656 3.81607V3.43004C22.8656 2.52045 22.5041 1.64819 21.861 1.00505C21.2178 0.361658 20.3455 0.000488281 19.4356 0.000488281H3.91234C2.87531 0.00230062 1.8813 0.415266 1.14806 1.14849C0.414812 1.88171 0.00205483 2.87572 0 3.91263V15.4264C0 16.6392 0.481859 17.8025 1.33942 18.66C2.19698 19.5175 3.36032 19.9993 4.57313 19.9993L20.0075 19.9995ZM20.5792 13.5187L16.6296 13.5189C16.3157 13.5148 16.062 13.2613 16.0581 12.9473V12.279C16.0581 11.9634 16.3139 11.7076 16.6296 11.7076H20.5864L20.5792 13.5187ZM2.28655 15.4266V7.47611C2.79586 7.7125 3.35102 7.83419 3.91232 7.83238H19.4356C19.7388 7.83238 20.0298 7.95277 20.2442 8.16715C20.4586 8.38153 20.579 8.67229 20.579 8.97546V9.41354H16.6293C15.8707 9.41561 15.1436 9.71828 14.6079 10.2555C14.0722 10.7925 13.7713 11.5203 13.7713 12.2789V12.9694C13.7791 13.7228 14.0833 14.4431 14.6183 14.9739C15.1532 15.5047 15.8759 15.8032 16.6293 15.8053H20.5862V17.1415L20.5865 17.1413C20.5865 17.4571 20.3304 17.7129 20.0148 17.7129H4.57303C3.96663 17.7129 3.38507 17.4722 2.95628 17.0434C2.52723 16.6146 2.28647 16.0328 2.28647 15.4264L2.28655 15.4266Z",
    fill: fill
  }));
};

exports["default"] = _default;